/**
 * 분석 화면 차트 공통 스타일 — chartTheme 의 축/범례 헬퍼에 그레이 5단계 팔레트를 입힌다.
 * (chartTheme 기본값은 대시보드 등 다른 화면이 같이 쓰므로 그대로 둔다)
 */
import { axisLabelStyle, legendTextStyle, chartColors, grayScale, navyScale } from "../../utils/chartTheme.js";

/** 분석 화면 시리즈 색 (청록 대신 네이비). 위험·증감 등 의미 색은 chartColors 그대로 사용 */
export const seriesColors = {
    primary: navyScale[0],
    accent: navyScale[2],
    soft: navyScale[4],
};

/** 히트맵 등 연속 색 범위 (연함 → 진함) */
export const navyRamp = ["#eef5fc", navyScale[4], navyScale[2], navyScale[1], navyScale[0]];

export const axisLabel = (overrides = {}) => axisLabelStyle({ color: grayScale[0], ...overrides });

export const axisLine = () => ({ lineStyle: { color: grayScale[3] } });

export const splitLine = (show = true) => ({ show, lineStyle: { type: "dashed", color: grayScale[4] } });

export const legendText = (overrides = {}) => legendTextStyle({ color: grayScale[0], ...overrides });

const WEEKDAY_LABEL_COLORS = { sat: chartColors.saturday, sun: chartColors.weekend };

/** 일자 라벨 색: 토요일 파랑, 일요일·공휴일 빨강, 평일 그레이 */
export function dayLabelColor(date, isHoliday) {
    const day = new Date(date).getDay();
    if (isHoliday || day === 0) return WEEKDAY_LABEL_COLORS.sun;
    if (day === 6) return WEEKDAY_LABEL_COLORS.sat;
    return grayScale[0];
}
